exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table tbody tr td[data-v-1e5f7864] {\n  vertical-align: top;\n}\n.table-responsive[data-v-1e5f7864] {\n  overflow: scroll;\n  margin-top: 20px;\n}\n.table[data-v-1e5f7864] {\n  width: auto;\n}\n", ""]);

// exports
